<template>
  <b-modal
    :id="'tracking-' + fulfillment.id.toString()"
    centered
    hide-footer
    hide-header
    size="xl"
    @show="getTrackingData()"
  >
    <div class="tracking-info">
      <div v-if="loading">
        <b-col class="text-center">
          <img v-if="processingGIF" alt="Processing..." class="processing-image" :src="processingGIF" />
        </b-col>
      </div>
      <div v-else-if="tracking">
        <div class="centered-block">
          <div class="step-title">Tracking Information</div>
        </div>
        <div class="summary">
          <div><label>Carrier:</label> {{tracking.carrier}}</div>
          <div><label>Status:</label> {{getStatusText(tracking.status)}}</div>
          <div v-if="tracking.est_delivery_date && tracking.est_delivery_date.length">
            <label>Est. Delivery Date:</label>
            {{estimatedDeliveryDate}}
          </div>
        </div>
        <b-table striped hover :items="details" :fields="detailFields" class="tracking-table">
          <template v-slot:cell(date)="data">
            <div>{{data.value}}</div>
            <div class="time">{{data.item.time}}</div>
          </template>
        </b-table>
      </div>
      <div v-else>
        <div class="centered-block">
          <div class="step-title">Invalid tracking ID or couldn't find any data</div>
        </div>
      </div>
    </div>
    <b-link block class="centered-block close-button" variant="secondary" @click="close()">&times;</b-link>
  </b-modal>
</template>

<script>
import { TrackingStatusStrings } from '../constants'
import { getShortTime, getShortDate } from '../utils'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'Tracking',
  props: {
    fulfillment: Object
  },
  data: function() {
    return {
      loading: false,
      tracking: null,
      detailFields: [
        {key: 'date'},
        {key: 'location'},
        {key: 'status'},
        {key: 'message'}
      ]
    }
  },
  computed: {
    ...mapGetters(['processingGIF']),
    details: function() {
      let details = []

      for (let detail of this.tracking.details) {
        let location = ''
        let country = detail.country || 'US'

        if (detail.city && detail.state) {
          location = detail.city + ', ' + detail.state + ', ' + country
        }

        details.push({
          date: getShortDate(detail.scan_date),
          time: getShortTime(detail.scan_date),
          location: location,
          status: this.getStatusText(detail.status),
          message: detail.message
        })
      }

      return details
    },
    estimatedDeliveryDate: function() {
      return getShortDate(this.tracking.est_delivery_date)
    }
  },
  methods: {
    getStatusText: function(status) {
      return TrackingStatusStrings[status]
    },
    close: function() {
      this.$bvModal.hide('tracking-' + this.fulfillment.id.toString())
    },
    getTrackingData() {
      if (!this.tracking) {
        this.loading = true

        axios.get('/fulfillments/' + this.fulfillment.id.toString() + '/').then(result => {
          console.log(result)
          this.tracking = result.data.tracking
          this.loading = false
        }, error => {
          console.error(error)
          this.loading = false
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
